// extracted by mini-css-extract-plugin
module.exports = {"buttons":"WorklogsXlsExport_buttons__3SoSI"};